import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Dumbbell, LineChart, User } from "lucide-react";

const tabs = [
  { to: "/dashboard", icon: Home, label: "Home", tid: "nav-home" },
  { to: "/workout", icon: Dumbbell, label: "Train", tid: "nav-train" },
  { to: "/progress", icon: LineChart, label: "Progress", tid: "nav-progress" },
  { to: "/profile", icon: User, label: "Profile", tid: "nav-profile" },
];

export default function BottomNav() {
  const loc = useLocation();
  // Bottom nav hidden on auth/onboarding/session screens
  if (loc.pathname === "/" || loc.pathname.startsWith("/login") || loc.pathname.startsWith("/register") || loc.pathname.startsWith("/forgot-password") || loc.pathname.startsWith("/reset-password") || loc.pathname.startsWith("/onboarding") || loc.pathname.startsWith("/session") || loc.pathname.startsWith("/admin")) return null;
  return (
    <nav className="fixed bottom-0 left-0 right-0 border-hair-t pb-safe" style={{ background: "rgba(10,10,10,0.9)", backdropFilter: "blur(12px)" }} data-testid="bottom-nav">
      <div className="max-w-md mx-auto flex justify-around items-center py-2">
        {tabs.map(({ to, icon: I, label, tid }) => (
          <NavLink key={to} to={to} data-testid={tid} className={({ isActive }) => `flex flex-col items-center gap-1 px-4 py-2 ${isActive ? "text-lime" : "text-t3"}`}>
            <I size={20} strokeWidth={1.6} />
            <span className="text-[10px] uppercase tracking-widest">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
